import { findClientBy } from '../../../redux/client.duck';

// Calcula la pagina (base 0) a partir de la pagina de la tabla
const toPageIndex = (page) => Math.max(0, Number.parseInt(page) - 1);

// Handlers comunes de los filtros de ingresos (monitor y envio de pagos).
// Mantienen el patron original: se muta `data`/`date` y luego se refresca el estado.
export const createIncomeFilterHandlers = ({
  data,
  setData,
  date,
  setDate,
  dispatch,
  addToast,
  search,
}) => {
  const refreshState = () => {
    setData({
      ...data,
    });
  };
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    });
  };
  const updateDateState = (value, id) => {
    setDate({
      ...date,
      [id]: value,
    });
  };
  const viewNotification = (msm, action) => {
    addToast(msm, {
      appearance: action,
      autoDismiss: true,
    });
  };
  const messageError = () => {
    if (data.error !== '') {
      viewNotification(data.error.error, 'error');
    }
  };
  const changeClient = (value) => {
    data.client = value === null ? { value: 0, label: '' } : value;
    refreshState();
  };
  // Cambio de pagina y tamanio de pagina
  const changePage = (page) => {
    data.page = toPageIndex(page);
    data.pendingData = true;
    refreshState();
    search();
  };
  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage;
    changePage(page);
  };
  const handlePageChange = async (page) => {
    changePage(page);
  };
  const onChangeDate = (dat) => {
    date.dateIni = dat._d;
    updateDateState(dat._d, 'dateIni');
  };
  const onChangeDateEnd = (dat) => {
    date.dateEnd = dat._d;
    updateDateState(dat._d, 'dateEnd');
  };
  // Busqueda de clientes para el AsyncSelect
  const loadDataClient = async (inputValue) => {
    if (inputValue !== undefined && inputValue.length > 3) {
      let json = {
        filter: inputValue,
        society: data.society.value,
        length: 20,
        page: 0,
      };
      data.clients = await dispatch(findClientBy(json));
      return data.clients;
    }
  };
  const promiseOptions = (inputValue) =>
    Promise.resolve(loadDataClient(inputValue));

  return {
    refreshState,
    updateState,
    updateDateState,
    viewNotification,
    messageError,
    changeClient,
    handlePerRowsChange,
    handlePageChange,
    onChangeDate,
    onChangeDateEnd,
    promiseOptions,
  };
};
